import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { CandidateJourneyStatus } from './candidate-journey-status.interface';
export class CandidateJourneyStatusService {
   async getCandidateJourneyStatuses(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<CandidateJourneyStatus>>>('/submission-states', { params: query });
      return response.data;
   }
}
